'use client'
import * as React from 'react'

/**
 * This context is meant to be used in client components that need productId; Its purpose is to purely avoid prop drilling.
 */
interface ProductIdContextValue {
  productId: string
}

const ProductIdContext = React.createContext<ProductIdContextValue>(null!)

interface ContextProviderProps extends React.PropsWithChildren {
  productId: string
}

export function ProductIdProvider({ productId, children }: ContextProviderProps) {
  return <ProductIdContext.Provider value={{ productId }}>{children}</ProductIdContext.Provider>
}

export function useProductId() {
  const context = React.useContext(ProductIdContext)
  if (!context) {
    throw new Error('`useProductId()` must be used within a `<ProductIdProvider />')
  }

  return context?.productId
}
